let routerInstance = null;

export const setRouterInstance = (router) => {
  routerInstance = router;
};

export const getRouterInstance = () => routerInstance;
